const Hammer = require("hammerjs");
const WeakMap = require("es6-weak-map");
const managers = new WeakMap();

function getHammerInstance(element, options = null) {
	let manager = managers.get(element);

	if (manager == null) {
		manager = new Hammer(element, options);
		managers.set(element, manager);
	}

	return manager;
}

module.exports = getHammerInstance;


// WEBPACK FOOTER //
// ./resources/js/helpers/hammer.js